<div class="chat-popup-container" *ngIf="showPopup">
    <div class="chat-popup animate-popup">
        <div class="chat-header">
            <span style="color: #ff7000;">Share</span>
            <button mat-icon-button class="icon-bubble close-btn" (click)="closeChatPopup()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="chat-body">
            <div class="share-container">
                <div class="share-option" (click)="shareWhatsApp()">
                    <img src="assets/images2/icons/icons8-whatsapp (1).svg" alt="">
                    <span>WhatsApp</span>
                </div>
                <div class="share-option" (click)="shareFacebook()">
                    <img src="assets/images2/icons/icons8-fb.svg" alt="">
                    <span>Facebook</span>
                </div>
                <div class="share-option" (click)="shareTwitter()" style="gap: 8px;justify-content: flex-end;">
                    <i class="fa-brands fa-x-twitter"></i>

                    <span>Twitter</span>
                </div>
                <div class="share-option" (click)="shareInstagram()">
                    <img src="assets/images2/icons/icons8-instagram-logo-94.png" alt="">
                    <span>Instagram</span>
                </div>
                <div class="share-option" (click)="shareMessenger()">
                    <img src="assets/images2/icons/images-messenger.webp" alt="">
                    <span>Messenger</span>
                </div>
                <div class="share-option" (click)="copyLink()" style="gap: 8px;justify-content: flex-end;">
                    <i class="fa-solid fa-link"></i>

                    <span>Copy link</span>
                </div>
            </div>
        </div>

    </div>
</div>